import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.ps-slider', {
        spaceBetween: 100,
        slidesPerGroup: 1,
        autoHeight:true,
        navigation: {
            nextEl: '.ps-slider-container .swiper-button-next',
            prevEl: '.ps-slider-container .swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
});
